// types
import { ChatsActionTypes, ChatsState } from './types';

export const INIT_STATE: ChatsState = {
    selectedInstance: {
        value:
            JSON.parse(localStorage.getItem('authUser') || 'null')?.data
                .instances[0] || null,
        label:
            JSON.parse(localStorage.getItem('authUser') || 'null')?.data
                .instances[0] || null
    },
    favourites: [],
    directMessages: [],
    hasMoreDirectMessages: false,
    searchChat: '',
    currentPageDirectMessages: 1,
    channels: [],
    selectedChat: null,
    chatUserDetails: {},
    chatUserMessages: [],
    totalMessages: 0,
    hasMoreUserMessages: false,
    currentPageUserMessages: 1,
    isOpenUserDetails: false,
    channelDetails: {},
    archiveContacts: []
};

const Chats = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case ChatsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ChatsActionTypes.GET_FAVOURITES:
                    return {
                        ...state,
                        favourites: action.payload.data,
                        isFavouritesFetched: true,
                        getFavouritesLoading: false
                    };
                case ChatsActionTypes.GET_DIRECT_MESSAGES:
                    return {
                        ...state,
                        directMessages:
                            action.payload.data.meta.currentPage ===
                                action.payload.data.meta.firstPage ||
                            action.payload.data.meta.total === 0
                                ? action.payload.data.data
                                : [
                                      ...new Set([
                                          ...state.directMessages,
                                          ...action.payload.data.data
                                      ])
                                  ],
                        hasMoreDirectMessages:
                            action.payload.data.meta.currentPage <
                            action.payload.data.meta.lastPage,
                        isDirectMessagesFetched: true,
                        getDirectMessagesLoading: false,
                        isContactsAdded: false
                    };
                case ChatsActionTypes.GET_CHANNELS:
                    return {
                        ...state,
                        channels: action.payload.data,
                        isChannelsFetched: true,
                        getChannelsLoading: false,
                        isChannelCreated: false
                    };
                case ChatsActionTypes.ADD_CONTACTS:
                    return {
                        ...state,
                        isContactsAdded: true,
                        addContactsLoading: false
                    };
                case ChatsActionTypes.CREATE_CHANNEL:
                    return {
                        ...state,
                        isChannelCreated: true,
                        createChannelLoading: false
                    };
                case ChatsActionTypes.GET_CHAT_USER_DETAILS:
                    return {
                        ...state,
                        chatUserDetails: action.payload.data.data[0],
                        isUserDetailsFetched: true,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.UPDATE_CHAT_USER_DETAILS:
                    return {
                        ...state,
                        chatUserDetails: {
                            ...state.chatUserDetails,
                            ...action.payload.data.data
                        },
                        isUserDetailsFetched: true,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.RESET_CHAT_USER_DETAILS:
                    return {
                        ...state,
                        chatUserDetails: {},
                        isUserDetailsFetched: true,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.GET_CHAT_USER_MESSAGES:
                    const newMessages = action.payload.data.data.sort(
                        (a: any, b: any) =>
                            a.updatedAt.localeCompare(b.updatedAt)
                    );

                    return {
                        ...state,
                        chatUserMessages:
                            action.payload.data.meta.currentPage ===
                                action.payload.data.meta.firstPage ||
                            action.payload.data.meta.total === 0
                                ? newMessages
                                : [
                                      ...new Set([
                                          ...newMessages,
                                          ...state.chatUserMessages
                                      ])
                                  ],
                        totalMessages: action.payload.data.meta.total,
                        hasMoreUserMessages:
                            action.payload.data.meta.currentPage <
                            action.payload.data.meta.lastPage,
                        isUserConversationsFetched: true,
                        getUserConversationsLoading: false,
                        isUserMessageSent: false,
                        isMessageDeleted: false,
                        isMessageForwarded: false
                    };
                case ChatsActionTypes.ON_SEND_MESSAGE:
                    return {
                        ...state,
                        isUserMessageSent: true,
                        selectedChat: {
                            conversationId:
                                action.payload.data.data.conversationId,
                            personId: action.payload.data.data.personId
                        }
                    };
                case ChatsActionTypes.RECEIVE_MESSAGE:
                case ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER:
                    return {
                        ...state,
                        chatUserMessages: action.payload.data
                    };
                case ChatsActionTypes.READ_MESSAGE:
                    return {
                        ...state,
                        isMessageRead: true,
                        chatUserMessages: action.payload.data
                    };
                case ChatsActionTypes.DELETE_MESSAGE:
                    return {
                        ...state,
                        isMessageDeleted: true
                    };
                case ChatsActionTypes.FORWARD_MESSAGE:
                    return {
                        ...state,
                        isMessageForwarded: true
                    };
                case ChatsActionTypes.DELETE_USER_MESSAGES:
                    return {
                        ...state,
                        isUserMessagesDeleted: true
                    };
                case ChatsActionTypes.GET_CHANNEL_DETAILS:
                    return {
                        ...state,
                        chatUserDetails: {
                            ...action.payload.data,
                            isChannel: true
                        },
                        isChannelDetailsFetched: true,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
                    return {
                        ...state,
                        isFavouriteContactToggled: true
                    };
                case ChatsActionTypes.GET_ARCHIVE_CONTACT:
                    return {
                        ...state,
                        archiveContacts: action.payload.data,
                        isArchiveContactFetched: true,
                        isContactArchiveToggled: false
                    };
                case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
                    return {
                        ...state,
                        isContactArchiveToggled: true
                    };
                case ChatsActionTypes.DELETE_IMAGE:
                    return {
                        ...state,
                        isImageDeleted: true
                    };
                default:
                    return { ...state };
            }

        case ChatsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ChatsActionTypes.GET_FAVOURITES:
                    return {
                        ...state,
                        isFavouritesFetched: false,
                        getFavouritesLoading: false
                    };
                case ChatsActionTypes.GET_DIRECT_MESSAGES:
                    return {
                        ...state,
                        isDirectMessagesFetched: false,
                        getDirectMessagesLoading: false
                    };
                case ChatsActionTypes.GET_CHANNELS:
                    return {
                        ...state,
                        isChannelsFetched: false,
                        getChannelsLoading: false
                    };
                case ChatsActionTypes.ADD_CONTACTS:
                    return {
                        ...state,
                        isContactsAdded: false,
                        addContactsLoading: false
                    };
                case ChatsActionTypes.CREATE_CHANNEL:
                    return {
                        ...state,
                        isChannelCreated: false,
                        createChannelLoading: false
                    };
                case ChatsActionTypes.GET_CHAT_USER_DETAILS:
                    return {
                        ...state,
                        isUserDetailsFetched: false,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.GET_CHAT_USER_MESSAGES:
                    return {
                        ...state,
                        chatUserMessages: {},
                        isUserConversationsFetched: false,
                        getUserConversationsLoading: false,
                        isUserMessageSent: false
                    };
                case ChatsActionTypes.ON_SEND_MESSAGE:
                    return {
                        ...state,
                        isUserMessageSent: false
                    };
                case ChatsActionTypes.DELETE_MESSAGE:
                    return {
                        ...state,
                        isMessageDeleted: false
                    };
                case ChatsActionTypes.FORWARD_MESSAGE:
                    return {
                        ...state,
                        isMessageForwarded: false
                    };
                case ChatsActionTypes.DELETE_USER_MESSAGES:
                    return {
                        ...state,
                        isUserMessagesDeleted: false
                    };
                case ChatsActionTypes.GET_CHANNEL_DETAILS:
                    return {
                        ...state,
                        isChannelDetailsFetched: false,
                        getUserDetailsLoading: false
                    };
                case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
                    return {
                        ...state,
                        isFavouriteContactToggled: false
                    };
                case ChatsActionTypes.GET_ARCHIVE_CONTACT:
                    return {
                        ...state,
                        isArchiveContactFetched: false
                    };
                case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
                    return {
                        ...state,
                        isContactArchiveToggled: false
                    };
                case ChatsActionTypes.READ_CONVERSATION:
                    return {
                        ...state,
                        isRead: false
                    };
                case ChatsActionTypes.DELETE_IMAGE:
                    return {
                        ...state,
                        isImageDeleted: true
                    };
                default:
                    return { ...state };
            }
        case ChatsActionTypes.GET_FAVOURITES: {
            return {
                ...state,
                getFavouritesLoading: true,
                isFavouritesFetched: false
            };
        }
        case ChatsActionTypes.GET_DIRECT_MESSAGES:
            return {
                ...state,
                isDirectMessagesFetched: false,
                getDirectMessagesLoading: true
            };
        case ChatsActionTypes.RESET_DIRECT_MESSAGES:
            return {
                ...state,
                isDirectMessagesFetched: false,
                getDirectMessagesLoading: false,
                directMessages: [],
                hasMoreDirectMessages: false,
                searchChat: '',
                currentPageDirectMessages: 1
            };
        case ChatsActionTypes.UPDATE_SEARCH_CHAT:
            return {
                ...state,
                searchChat: action.payload,
                currentPageDirectMessages: 1
            };
        case ChatsActionTypes.UPDATE_CURRENT_PAGE_DIRECT_MESSAGES:
            return {
                ...state,
                currentPageDirectMessages: action.payload
            };
        case ChatsActionTypes.GET_CHANNELS:
            return {
                ...state,
                isChannelsFetched: false,
                getChannelsLoading: true
            };
        case ChatsActionTypes.ADD_CONTACTS:
            return {
                ...state,
                isContactsAdded: false,
                addContactsLoading: true
            };
        case ChatsActionTypes.CREATE_CHANNEL:
            return {
                ...state,
                isChannelCreated: false,
                createChannelLoading: true
            };
        case ChatsActionTypes.CHANGE_SELECTED_CHAT:
            return {
                ...state,
                selectedChat: action.payload
            };
        case ChatsActionTypes.GET_CHAT_USER_DETAILS:
            return {
                ...state,
                isUserDetailsFetched: false,
                getUserDetailsLoading: true
            };
        case ChatsActionTypes.GET_CHAT_USER_MESSAGES:
            return {
                ...state,
                isUserConversationsFetched: false,
                getUserConversationsLoading: true,
                isUserMessageSent: false
            };
        case ChatsActionTypes.UPDATE_CURRENT_PAGE_USER_MESSAGES:
            return {
                ...state,
                currentPageUserMessages: action.payload
            };
        case ChatsActionTypes.TOGGLE_USER_DETAILS_TAB:
            return {
                ...state,
                isOpenUserDetails: action.payload
            };
        case ChatsActionTypes.CHANGE_INSTANCE:
            return {
                ...state,
                selectedInstance: action.payload
            };
        case ChatsActionTypes.ON_SEND_MESSAGE:
            return {
                ...state,
                isUserMessageSent: false
            };
        case ChatsActionTypes.DELETE_MESSAGE:
            return {
                ...state,
                isMessageDeleted: false
            };
        case ChatsActionTypes.FORWARD_MESSAGE:
            return {
                ...state,
                isMessageForwarded: false
            };
        case ChatsActionTypes.DELETE_USER_MESSAGES:
            return {
                ...state,
                isUserMessagesDeleted: false
            };
        case ChatsActionTypes.GET_CHANNEL_DETAILS:
            return {
                ...state,
                isChannelDetailsFetched: false,
                getUserDetailsLoading: true
            };
        case ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT:
            return {
                ...state,
                isFavouriteContactToggled: false
            };
        case ChatsActionTypes.GET_ARCHIVE_CONTACT:
            return {
                ...state,
                isArchiveContactFetched: false
            };
        case ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT:
            return {
                ...state,
                isContactArchiveToggled: false
            };
        case ChatsActionTypes.DELETE_IMAGE:
            return {
                ...state,
                isImageDeleted: false
            };
        default:
            return { ...state };
    }
};

export default Chats;
